import VentesDashboard from "@features/ventes/components/VentesDashboard";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ShoppingCart } from "lucide-react";

export const Route = createFileRoute("/_app/ventes/")({
  staticData: {
    title: "Ventes",
    icon: ShoppingCart,
    tab_icon: ShoppingCart,
    permission: PERMISSIONS.VENTES.CLIENTS.VIEW,
    section: "Ventes",
    order: 10,
    description: "Module Ventes",
    module: "ventes",
    showInTab: false,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: VentesDashboard,
});
